import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import AttitudeComparisionDetail from './AttitudeComparisionDetail';
import { MRI_STUDY_NAME_FLAG } from '../../../constants';

class AttitudesTripleComparisionPersona extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRadioButton: 'index',
      selectedAttitude: 'Agree',
    };
  }

  render() {
    const attitudesList = [];
    if (
      this.props.attitudes !== undefined &&
      this.props.insight360AttitudeAgreeChoice !== undefined
    ) {
      _.forEach(this.props.attitudes, attitude => {
        const attitudeGroup = _.find(
          attitude.attitudeGroups,
          this.props.insight360AttitudeAgreeChoice,
        );
        if (attitudeGroup !== undefined) {
          attitudesList.push(
            attitudeGroup[this.props.insight360AttitudeAgreeChoice],
          );
        }
      });
    }

    return (
      <div className="row fullwidth attitudeCardPdf">
        <div className="row fullwidth demographic-detail-columns">
          {!_.isEmpty(attitudesList) &&
            attitudesList.length > 0 &&
            attitudesList.map((attitude, index) => (<div key={index}>
              <div className="columns large-4 medium-4 small-4 attitudeTriplePersonaPdf">
                {attitude.map((attitudeDetail, i) => (<div
                  className="row fullwidth demographic-detail-columns"
                  key={`att-t${index}${i}`}
                >
                  <div
                    className="columns large-12 small-12 medium-12"
                    id={this.props.studyName === MRI_STUDY_NAME_FLAG ? 'pdfAttitudeMriPersonaGridRowLen' :
                    'pdfAttitudePersonaGridRowLen'}
                  >
                    {
                      <AttitudeComparisionDetail
                        key={i}
                        categoryName={attitudeDetail.categoryName}
                        statement={
                          attitudeDetail.data !== undefined
                            ? attitudeDetail.data.label
                            : 'N/A'
                        }
                        attitudeDetail={
                          attitudeDetail.data !== undefined
                            ? attitudeDetail.data.value
                            : {}
                        }
                        selectedIcon={_.camelCase(
                          attitudeDetail.icon.replace('.png', ''),
                        )}
                        selectedTab={this.props.selectedTab}
                        personaIndex={index}
                      />
                    }
                  </div>
                </div>
                )
                )}
              </div>
            </div>
            )
            )}
        </div>
      </div>
    );
  }
}

AttitudesTripleComparisionPersona.propTypes = {
  attitudes: PropTypes.arrayOf(PropTypes.object),
  insight360AttitudeAgreeChoice: PropTypes.string,
  selectedTab: PropTypes.string,
};

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(AttitudesTripleComparisionPersona);
